import React, { useState, useEffect } from 'react';
import '../styles/GalleryComponent.css';

// Import all images
import show1 from '../assets/Gallary/component/show_1.jpg';
import show2 from '../assets/Gallary/component/show_2.jpg';
import show3 from '../assets/Gallary/component/show_3.jpg';
import show4 from '../assets/Gallary/component/show_4.jpg';
import show5 from '../assets/Gallary/component/show_5.jpg';
import show6 from '../assets/Gallary/component/show_6.jpg';
import show7 from '../assets/Gallary/component/show_7.jpeg';
import show8 from '../assets/Gallary/component/show_8.jpeg';

const GalleryComponent = () => {
  const images = [show1, show2, show3, show4, show5, show6, show7, show8];
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  // Auto-advance slideshow
  useEffect(() => {
    const timer = setInterval(() => {
      nextSlide();
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(timer);
  }, [currentImageIndex]);

  const nextSlide = () => {
    if (!isTransitioning) {
      setIsTransitioning(true);
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
      setTimeout(() => setIsTransitioning(false), 500); // Match transition duration
    }
  };

  const prevSlide = () => {
    if (!isTransitioning) {
      setIsTransitioning(true);
      setCurrentImageIndex((prevIndex) => 
        prevIndex === 0 ? images.length - 1 : prevIndex - 1
      );
      setTimeout(() => setIsTransitioning(false), 500); // Match transition duration
    }
  };

  const goToSlide = (index) => {
    if (!isTransitioning && index !== currentImageIndex) {
      setIsTransitioning(true);
      setCurrentImageIndex(index);
      setTimeout(() => setIsTransitioning(false), 500); // Match transition duration
    }
  };

  return (
    <div className="gallery-container">
      <div className="gallery-content">
        <button className="gallery-nav prev" onClick={prevSlide}>
          ‹
        </button>
        <div className="gallery-slides">
          {images.map((image, index) => (
            <img
              key={index}
              src={image}
              alt={`Gallery image ${index + 1}`}
              className={`gallery-image ${index === currentImageIndex ? 'active' : ''}`}
              style={{ opacity: index === currentImageIndex ? 1 : 0 }}
            />
          ))}
        </div>
        <button className="gallery-nav next" onClick={nextSlide}>
          ›
        </button>
      </div>
      <div className="gallery-dots">
        {images.map((_, index) => (
          <button
            key={index}
            className={`gallery-dot ${index === currentImageIndex ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default GalleryComponent; 